import _ from "lodash";
import {
  MS_FILE_VIEWER_SUPPORTED_MIMETYPE,
  GOOGLE_FILE_VIEWER_SUPPORTED_MIMETYPE,
} from "Constants";
import {
  ATTACHMENT_INPUT_ATTRIBUTES,
  ATTACHMENT_OMIT_ATTRIBUTES,
} from "store/static";

export const customizer = (objValue, srcValue) => {
  if (_.isArray(objValue)) {
    return objValue.concat(srcValue);
  }
};

export const getpdfTronEditModeSupported = ({ file }) => {
  if (_.isEqual(_.get(file, "type", ""), "FILE")) {
    const mimeType = _.get(file, "mimeType", "");
    if (_.isEqual(mimeType, "application/pdf")) return true;
    if (
      _.includes(GOOGLE_FILE_VIEWER_SUPPORTED_MIMETYPE, mimeType) ||
      _.includes(MS_FILE_VIEWER_SUPPORTED_MIMETYPE, mimeType)
    ) {
      return false;
    }
  }
  return false;
};

export const cleanAttachmentObject = ({ attachment }) => {
  attachment = {
    ...attachment,
    id: attachment?.attachmentId || attachment?.id,
  };
  const attachmentObj = _.pick(attachment, ATTACHMENT_INPUT_ATTRIBUTES);
  return _.omit(attachmentObj, ATTACHMENT_OMIT_ATTRIBUTES);
};

//finds string like "date="20220313194644+05'30'"
const dateStringRegEx = / (date="D:\d{14})(\+\d{2}\'?\d{2}\'?)?\"/;
/*
util to compare two xdf strings, ignoring the date field
sometime two xdf might be different even if they have the same content,
based on time exported, so this util helps to compare two xdf strings
*/
export const isXdfEqual = (xdf1, xdf2) => {
  try {
    const modifiedXdf1 = xdf1.replace(dateStringRegEx, "");
    const modifiedXdf2 = xdf2.replace(dateStringRegEx, "");
    return _.isEqual(modifiedXdf1, modifiedXdf2);
  } catch (e) {}
  return _.isEqual(xdf1, xdf2);
};
